// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-AboutCardContainer-module--cls1--1Jvwb","cls2":"styles-AboutCardContainer-module--cls2--W0wUT styles-AboutCardContainer-module--cls1--1Jvwb"};